import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaCheck } from "react-icons/fa";
import GreenBorderline from '../updatehackinginternship/Assets/ProcessAssets/skgreenborder.png'
import Metasploit from '../updatehackinginternship/Assets/ToolsAssets/Metasploit.svg'
import nmap from '../updatehackinginternship/Assets/ToolsAssets/nmap.png'
import wireshark from '../updatehackinginternship/Assets/ToolsAssets/wireshark.png'
import kaliLinux from '../updatehackinginternship/Assets/ToolsAssets/kaliLinux.png'
// import Metasploit from '../updatehackinginternship/ToolsAssets/Metasploit.svg'

// --- START: CSS FOR NEW PROFESSIONAL CARD DESIGN ---
const styles = `
  /* ⭐️⭐️⭐️ CRITICAL FIX FOR STICKY ANIMATION ⭐️⭐️⭐️
    Ensure your global CSS file (index.css or App.css) has 'overflow-x: clip;' 
    on the 'body' or '#root' element, NOT 'overflow-x: hidden'.
  */

  body {
    background-color: #ffffff; /* White background for the page */  
    overflow-x: clip;

  }

  .projects-background {
    background-color: #ffffff;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    overflow: clip; 
  }

  .main-heading {
    position: relative;
    display: inline-block;
    padding-bottom: 10px;
    color: #000000; /* Black heading */
  }

  .main-heading::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 25%;
    width: 50%;
    height: 4px;
    background-color: #ffc107;
    border-radius: 2px;
  }

  /* --- Sticky Animation Logic (Unchanged) --- */
  .sticky-stack-container {
    position: relative;
    height: calc(100vh + var(--card-count)); 
  }

  .project-card-sticky-wrapper {
    position: sticky; 
    
    transform-origin: center top;
    border-radius: 16px;
  }

  /* --- NEW PROFESSIONAL CARD DESIGN --- */
  .pro-card-body {
    padding: 2.5rem;
    background-color: #ffffff;
    // border: 1px solid #e9ecef;
    color: #212529;    
    border-radius: 20px;
  }

  .pro-card-left-col h6 {
    font-weight: 700;
    font-size: 0.9rem;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }

  .pro-card-left-col h3 {
    font-size: 2.5rem;
    font-weight: 700;
    color: #000000;
    line-height: 1.2;
  }

  .duration-text {
    font-size: 0.9rem;
    color: #6c757d;
    margin-top: 1rem;
  }
  
  .description-text {
      color: #495057;
      font-size: 1rem;
      line-height: 1.7;
      margin-bottom: 1.5rem;
  }

  .deliverables-title {
      font-weight: 600;
      font-size: 1rem;
      color: #000;
      margin-bottom: 1rem;
  }

  .deliverables-list {
    padding-left: 0;
    margin: 0;
    list-style: none;
  }

  .deliverables-list li {
    margin-bottom: 10px;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    color: #495057;
  }
  
  .check-icon {
    margin-right: 0.75rem;
    font-size: 0.8rem;
  }

  .content-divider {
    border-left: 1px solid #e9ecef;
    height: auto;
  }
  
  .tool-logos {
    opacity: 0.6;
    // filter: grayscale(100%);
  }
  /* The max-height rule that was here has been removed to allow inline styles to work */
  .tool-logos .col {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  /* --- RESPONSIVE STYLES --- */
  @media (max-width: 991.98px) {
    .pro-card-body {
      padding: 1.5rem;
    }
    .pro-card-left-col h3 {
      font-size: 1.8rem;
    }
    .content-divider {
        display: none; /* Hide vertical divider on mobile */
    }
    .pro-card-right-col {
        padding-top: 1rem;
        border-top: 1px solid #e9ecef; /* Use horizontal divider on mobile */
        margin-top: 0.5rem;
    }
  }
`;
// --- END: CSS ---


// --- Main Section Component ---
const CybersecurityProjects = () => {
  // MODIFICATION 1: Added a 'height' property to each tool object.
  const projectsData = [
  {
    "id": 1,
    "title": "Client System Hacking",
    "duration": "Duration: 40 Hours",
    "description": "Perform authorized simulated attacks on a client's internal systems to identify vulnerabilities, exploit weaknesses in a controlled environment, and recommend system hardening measures.",
    "deliverables": [
      { "text": "Vulnerability Assessment" },
      { "text": "Exploit Demonstrations" },
      { "text": "System Hardening Recommendations" },
      { "text": "Professional Report" }
    ],
    "tools": [
      { "name": "Metasploit", "logo": "https://tryhackme-images.s3.amazonaws.com/room-icons/66704dd0e54a1f39bff7b1a1-1735574256490", "height": "50px" },
      { "name": "Nmap", "logo": "https://assets.tryhackme.com/img/modules/nmap.png", "height": "50px" },
      { "name": "Wireshark", "logo": "https://miro.medium.com/1*sOhbhWnnmBx7TxHddLPW0Q.png", "height": "50px" },
      { "name": "Kali Linux", "logo": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQahb-kUMUnLJpfBkowofEU7eU91sZGNFPpSw&s", "height": "50px" }
    ],
    "accentColor": "#0d6efd"
  },
  {
    "id": 2,
    "title": "SOC Analysis of Client Website",
    "duration": "Duration: 35 Hours",
    "description": "Operate in a simulated Security Operations Center to monitor the client's website, analyze logs with a SIEM, and identify indicators of compromise to enable timely response.",
    "deliverables": [
      { "text": "SIEM Log Analysis" },
      { "text": "Incident Triage" },
      { "text": "IOC Identification" },
      { "text": "Response Playbook" }
    ],
    "tools": [
      { "name": "Splunk", "logo": "https://upload.wikimedia.org/wikipedia/commons/f/f8/Splunk_logo.png", "height": "35px" },
      { "name": "Suricata", "logo": "https://suricata.io/wp-content/uploads/2023/09/Logo-Suricata-vert-R.jpg", "height": "30px" },
      { "name": "VirusTotal", "logo": "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/VirusTotal_logo.svg/2560px-VirusTotal_logo.svg.png", "height": "38px" },
      { "name": "Wireshark", "logo": "https://miro.medium.com/1*sOhbhWnnmBx7TxHddLPW0Q.png", "height": "30px" }
    ],
    "accentColor": "#198754"
  },
  {
    "id": 3,
    "title": "Virus & Malware Development using AI",
    "duration": "Duration: 50 Hours",
    "description": "Study malware behavior safely in sandboxes, use static and dynamic analysis, and develop machine-learning models to simulate and classify malware behaviors for research and defense development.",
    "deliverables": [
      { "text": "Safe Malware Sandbox Analysis" },
      { "text": "Static & Dynamic Reports" },
      { "text": "ML Classifier for Malware" },
      { "text": "Research Paper" }
    ],
    "tools": [
      { "name": "Ghidra", "logo": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToKNbl8D_yrnjGqKDaiX2VwOE0fYYQEqzTvw&s", "height": "30px" },
      { "name": "IDA Pro", "logo": "https://softwareasli.com/wp-content/uploads/2019/08/IDA-Pro-Computer-License-Linux.png", "height": "35px" },
      { "name": "TensorFlow", "logo": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS1MM722gHwGJMd1v-wMHmy2ve9OmPHYj6tmg&s", "height": "38px" },
      { "name": "Python", "logo": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/1200px-Python-logo-notext.svg.png", "height": "38px" }
    ],
    "accentColor": "#ffc107"
  },
  {
    "id": 4,
    "title": "Performing Penetration Testing on Client Website",
    "duration": "Duration: 40 Hours",
    "description": "Conduct full web-application penetration testing against a sandboxed client website to discover OWASP Top 10 vulnerabilities and produce actionable remediation guidance.",
    "deliverables": [
      { "text": "Recon & Mapping" },
      { "text": "Vulnerability Exploitation" },
      { "text": "Post-Exploitation Analysis" },
      { "text": "Penetration Test Report" }
    ],
    "tools": [
      { "name": "Burp Suite", "logo": "data:image/png;base64,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", "height": "35px" },
      { "name": "OWASP ZAP", "logo": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyitSrR-N1hmQRo-pklFJnznIloT8A8VPzZQ&s", "height": "40px" },
      { "name": "SQLMap", "logo": "https://repository-images.githubusercontent.com/646067896/c00973dd-5cb3-4011-8d28-a11d36354fe4", "height": "32px" },
      { "name": "Nmap", "logo": "https://assets.tryhackme.com/img/modules/nmap.png", "height": "35px" }
    ],
    "accentColor": "#dc3545"
  },
  {
    "id": 5,
    "title": "Hacking Tool Development",
    "duration": "Duration: 30 Hours",
    "description": "Design and build security tooling to automate offensive and defensive tasks — with emphasis on safe, ethical development, testing, and code review practices.",
    "deliverables": [
      { "text": "Design Specification" },
      { "text": "Prototype Tool" },
      { "text": "Automated Tests" },
      { "text": "Code Review & Demo" }
    ],
    "tools": [
      { "name": "Python", "logo": "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Python-logo-notext.svg/1200px-Python-logo-notext.svg.png", "height": "38px" },
      { "name": "Go", "logo": "https://app-ld-img.s3.amazonaws.com/badge/go-badge-avatar-f8a039ef-d328-49b1-89ad-2e2b4493cacc.png", "height": "35px" },
      { "name": "Git", "logo": "https://img.icons8.com/color/48/git.png", "height": "30px" },
      { "name": "Docker", "logo": "https://img.icons8.com/fluency/48/docker.png", "height": "38px" }
    ],
    "accentColor": "#6f42c1"
  },
  {
    "id": 6,
    "title": "Web Server Hacking of Client Network",
    "duration": "Duration: 45 Hours",
    "description": "Analyze and test web servers on a client's network for configuration and software vulnerabilities, perform controlled exploitation and propose remediation steps to secure hosting infrastructure.",
    "deliverables": [
      { "text": "Server Vulnerability Scan" },
      { "text": "Exploit Proof-of-Concepts" },
      { "text": "Configuration Hardening" },
      { "text": "Security Audit Report" }
    ],
    "tools": [
      { "name": "Nmap", "logo": "https://assets.tryhackme.com/img/modules/nmap.png", "height": "35px" },
      { "name": "Nikto", "logo": "https://miro.medium.com/1*YmJFZADlnLTinxfDag4Ajg.png", "height": "32px" },
      { "name": "Burp Suite", "logo": "data:image/png;base64,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", "height": "35px" },
      { "name": "OpenVAS", "logo": "https://media.licdn.com/dms/image/v2/D4D12AQHvVfgPGBfg8w/article-cover_image-shrink_600_2000/article-cover_image-shrink_600_2000/0/1662891492184?e=2147483647&v=beta&t=vZAsUlqGkg2ZpELpDMJAh2Mnca9IsnoTD07K_zaLyGQ", "height": "35px" }
    ],
    "accentColor": "#fd7e14"
  },
  {
    "id": 7,
    "title": "Hardware Hacking Tools Development",
    "duration": "Duration: 40 Hours",
    "description": "Design and build hardware tools and firmware utilities for testing and securing embedded devices; includes hardware debugging, firmware extraction, and safe radio analysis.",
    "deliverables": [
      { "text": "Hardware Tool Prototype" },
      { "text": "Firmware Extraction & Analysis" },
      { "text": "Radio/Protocol Tests" },
      { "text": "Hardware Security Audit" }
    ],
    "tools": [
      { "name": "Raspberry Pi", "logo": "https://www.svgrepo.com/show/303239/raspberry-pi-logo.svg", "height": "38px" },
      { "name": "Arduino", "logo": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQeXtOGOpaVhOkDTft1xonx9oHLp1HQStNYLA&s", "height": "35px" },
      { "name": "Binwalk", "logo": "https://fsa2-assets.imgix.net/assets/Logos/binwalk-logo.png?auto=compress%2Cformat&crop=focalpoint&domain=fsa2-assets.imgix.net&fit=crop&fp-x=0.5&fp-y=0.5&h=586&ixlib=php-3.3.1&w=1200", "height": "35px" },
      { "name": "JTAGulator", "logo": "https://www.fabtolab.com/image/cache/data/Accessories/Programmer%20and%20Debugger/32115-500x500.jpg", "height": "32px" }
    ],
    "accentColor": "#20c997"
  }
]

  
  const containerStyle = { '--card-count': projectsData.length };

  return (
    <>
      <style>{styles}</style>
      <div className="projects-background">
        <Container className="py-5 text-center">
            <h4 className="text-muted fw-light">PROJECTS</h4>
            <h1 className="display-5 fw-bold">
              Gain Real Experience With LIVE Projects
              <br />
              Even Before You Start Working
            </h1>

             <img src={GreenBorderline} alt="GreenBorderline" style={{ width: "250px", height: "8.59px", marginTop: "-15px" }} />
        </Container>
        <div className="sticky-stack-container" style={containerStyle}>
          {projectsData.map((project, index) => {
            const wrapperStyle = {
              top: `calc(80px + ${index * 15}px)`,
              transform: `scale(${1 - (projectsData.length - 1 - index) * 0.02})`,
            };
            return (
              <div key={project.id} className="project-card-sticky-wrapper shadow" style={wrapperStyle}>
                <Card className='border-0'>
                  <Card.Body className="pro-card-body">
                    <Row>
                      <Col md={5} className="pro-card-left-col text-start">
                        <h6 style={{ color: project.accentColor }}>PROJECT {project.id}</h6>
                        <h3 className="fw-bold">{project.title}</h3>
                        <p className="duration-text">{project.duration}</p>
                      </Col>
                      <Col md={1} className="d-none d-md-block">
                          <div className="content-divider my-0 "></div>
                      </Col>
                      <Col md={6} className="pro-card-right-col d-flex flex-column justify-content-between">
                        <div>
                            <p className=" fs-5 description-text text-start">{project.description}</p>
                            <h5 className="deliverables-title text-start my-2">Key Deliverables</h5>
                            <ul className="list-unstyled deliverables-list">
                              {project.deliverables.map((item, i) => (
                                <li key={i}>
                                  <FaCheck className="check-icon" style={{ color: project.accentColor }} />
                                  {item.text}
                                </li>
                              ))}
                            </ul>
                        </div>
                        
                      </Col>
                      <Row className="align-items-center tool-logos mt-4">
                          {/* MODIFICATION 2: Added an inline style to the img tag to apply the custom height */}
                          {project.tools.map((tool, i) => (
                            <Col key={i}>
                                <img 
                                    src={tool.logo} 
                                    alt={tool.name} 
                                    style={{ height: '50px' }} 
                                />
                            </Col>
                          ))}
                        </Row>
                    </Row>
                  </Card.Body>
                </Card>
              </div>
            );
          })}
        </div>
        
      </div>
    </>
  );
};

export default CybersecurityProjects;